module.exports = __webpack_public_path__ + "img/569-42dfb3.png";